import React from 'react';

import { METAMASK_URL } from '../constants.js';
import metamaskImg from '../images/metamask-img.png';
import './MetamaskLink.css';

export default () => (
    <div className="metamaskLink">
        <a href={METAMASK_URL} target="_blank">
            <img className="metamaskLink-image" src={metamaskImg} alt="Metamask Link" />
        </a>
    </div>
);



// WEBPACK FOOTER //
// ./src/components/MetamaskLink.js